export default __webpack_public_path__ + "static/media/iconPaymentCard.784ff2ca.svg";